import React, { useState, useEffect } from 'react';
import Modal from 'react-modal';
import baseURL from '../url';
import './Cart.css';
import whatsappIcon from '../../images/wpp.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faShoppingCart, faTrash, faUserPlus, faCheck, faLock } from '@fortawesome/free-solid-svg-icons';
import { Link as Anchor, useLocation } from "react-router-dom";
import moneda from '../moneda';
import Swal from 'sweetalert2';
import { ToastContainer, toast } from 'react-toastify';
import { ftMostrarPrecioNormalMayoreo } from '../ProductsPage/ProductosPageHelper';
import cuponImage from '../../images/descuento.webp';
import noStockImage from '../../images/no_stock.png';
import { useConfig } from '../../context/ConfigContext.js';
import { useCliente } from '../../context/ClienteContext.jsx';
import { clienteFetch } from '../../utils/api';
export default function Cart() {
    const { Cart: cartConfig } = useConfig();
    const { cliente, register, login } = useCliente();
    const [cartItems, setCartItems] = useState([]);
    const [productos, setProductos] = useState([]);
    const [loading, setLoading] = useState(true);
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [modalIsOpen2, setModalIsOpen2] = useState(false);
    const [isFocused, setIsFocused] = useState(false);
    const [noteText, setNoteText] = useState('');
    const [location, setLocation] = useState('');
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [telefono, setTelefono] = useState('');
    const [direccion, setDireccion] = useState('');
    const [codigo, setCodigo] = useState('');
    const [contactos, setContactos] = useState([]);
    const [descuento, setDescuento] = useState(0);
    const [codigoValido, setCodigoValido] = useState(false);
    const [totalPrice, setTotalPrice] = useState(0);
    const [paymentMethod, setPaymentMethod] = useState('efectivo');
    const [deliveryOption, setDeliveryOption] = useState('delivery');
    const [address, setAddress] = useState('');
    const [cuponAplicado, setCuponAplicado] = useState(localStorage.getItem('cupon') || '');
    const [cupon, setCupon] = useState("");
    const [sincronizarStates, setSincronizarStates] = useState(false);
    const [codigos, setCodigos] = useState([]);
    const [shippingCost, setShippingCost] = useState(160); // si la opción predeterminada es express, inicia con 160
    const locationRouterDom = useLocation();
    // Si NO está en "/Productos", permitimos anclar los links:
    const [activateAnchor] = useState(
        locationRouterDom.pathname !== "/Productos"
    );
    useEffect(() => {
        cargarContacto();
    }, []);

    // Sincronizar con state cuponAplicado
    useEffect(() => {
        if (!sincronizarStates) return;
        const cupones = codigos.map((item) => item.codigo);
        if (cupones.includes(cupon.toUpperCase())) {
            setCuponAplicado(cupon);
        }
    }, [sincronizarStates]);

    useEffect(() => {
        // Calcular el precio total al cargar el carrito o al actualizar los productos
        let totalPriceCalc = 0;
        cartItems.forEach(item => {
            totalPriceCalc += item.precio * item.cantidad;
        });
        setTotalPrice(totalPriceCalc);
    }, [cartItems]);

    const cargarContacto = () => {
        fetch(`${baseURL}/api/contacto`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setContactos(data.contacto.reverse()[0] || []);
            })
            .catch(error => console.error('Error al cargar contactos:', error));
    };

    // Calcular precio total (sin envío) y aplicar descuento
    useEffect(() => {
        let total = 0;
        const codigoDescuento = codigos.find(
            (item) => item.codigo === cuponAplicado
        );
        let descuentoActualizado = codigoDescuento ? codigoDescuento.descuento : 0;
        setDescuento(descuentoActualizado);

        cartItems.forEach((item) => {
            const precioUnitario = ftMostrarPrecioNormalMayoreo({ cuponAplicado, producto: item });
            const cantidad = Number(item.cantidad) || 0;
            const subtotal = Number(precioUnitario) * cantidad;
            
            
            // Validar que el subtotal sea un número válido
            if (!isNaN(subtotal) && isFinite(subtotal)) {
                total += subtotal;
            }
        });
        
        // Asegurar que el total sea un número válido
        const finalTotal = isNaN(total) || !isFinite(total) ? 0 : total;
        setTotalPrice(finalTotal);
    }, [cartItems, cuponAplicado, codigos]);

    // Determinar costo de envío cuando cambie `deliveryOption`
    useEffect(() => {
        // Si es express -> $160
        // Si es mayoreo -> $250
        // Si es correos -> $60
        // Si es moto -> costo al recibir

        if (deliveryOption === "express") {
            setShippingCost(160);
        } else if (deliveryOption === "mayoreo") {
            setShippingCost(250);
        } else if (deliveryOption === "correos") {
            setShippingCost(60);
        } else {
            // 'moto'
            setShippingCost(0);
        }
    }, [deliveryOption]);


    useEffect(() => {
        cargarProductos();
    }, [isFocused]);

    useEffect(() => {
        const fetchCartItems = async () => {
            const cart = JSON.parse(localStorage.getItem('cart')) || [];
            const promises = cart.map(async (cartItem) => {
                const producto = productos.find(producto => producto.idProducto === cartItem.idProducto);
                const baseItem = producto ? producto : cartItem; // fallback conserva stock/talla del localStorage
                return {
                    ...baseItem,
                    cantidad: cartItem.cantidad,
                    item: cartItem.item,
                };
            });

            Promise.all(promises)
                .then((items) => {
                    setCartItems(items);
                    setLoading(false);
                })
                .catch((error) => {
                    console.error('Error al obtener detalles del carrito:', error);
                    setLoading(false);
                });
        };

        fetchCartItems();
    }, [productos, isFocused]);

    // Auto-rellenar datos del cliente logueado al abrir el formulario de pedido
    useEffect(() => {
        if (!modalIsOpen2 || !cliente) return;
        setName(cliente.nombre || '');
        setTelefono(cliente.telefono || '');
        setEmail(cliente.email || '');
        const dir = cliente.direcciones?.find(d => d.esPredeterminada == 1) || cliente.direcciones?.[0];
        if (dir) {
            const partes = [dir.calle, dir.colonia, dir.ciudad, dir.codigoPostal].filter(Boolean);
            setAddress(partes.join(', '));
        }
    }, [modalIsOpen2, cliente]);

    // Abrir y cerrar el segundo modal (Detalles)
    const openModal2 = async () => {

        //revisamos si hay stock suficiente
        const formData = new FormData();
        formData.append("productos", JSON.stringify(cartItems));

        const response = await fetch(`${baseURL}/api/productos/stock-check`, {
            method: "POST",
            body: formData,
        });

        const data = await response.json();
        if (data.mensaje == 'Ok') {
            setModalIsOpen2(true);
        } else {

            Swal.fire({
                title: 'Lo sentimos nos falta stock',
                html: data.mensaje,
                imageUrl: noStockImage, // Imagen importada
                imageWidth: 100, // Ancho de la imagen
                imageHeight: 100,
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sí, ajustar',
                cancelButtonText: 'No',
            }).then((result) => {
                if (result.isConfirmed) {
                    const index = cartItems.findIndex(i => i.idProducto === data.idProducto && i.item === data.item);

                    let nuevaCantidad = 0;

                    if (data.item === 'Ch') {
                        nuevaCantidad = data.stockItem1;
                    } else if (data.item === 'M') {
                        nuevaCantidad = data.stockItem2;
                    } else if (data.item === 'G') {
                        nuevaCantidad = data.stockItem3;
                    } else if (data.item === 'Xg') {
                        nuevaCantidad = data.stockItem4;
                    } else if (data.item === 'Xxg') {
                        nuevaCantidad = data.stockItem5;
                    }

                    if (index !== -1) {
                        // Si lo encontramos, actualizar la cantidad
                        const updatedCartItems = [...cartItems];
                        updatedCartItems[index].cantidad = nuevaCantidad;
                        setCartItems(updatedCartItems);
                        localStorage.setItem("cart", JSON.stringify(updatedCartItems));
                        window.dispatchEvent(new Event('cartUpdated'));
                    } else {
                        // Item no encontrado
                    }

                }
            });
        }

    }

    const cargarProductos = () => {
        fetch(`${baseURL}/api/productos/catalogo`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setProductos(data.productos || []);
            })
            .catch(error => console.error('Error al cargar productos:', error));
    };

    const obtenerImagen = (item) => {
        return item.imagen1 || item.imagen2 || item.imagen3 || item.imagen4 || null;
    };

    const getStockDisponible = (producto, talla) => {
        if (!producto) return 0;
        const stockMap = {
            Ch: parseInt(producto.stockItem1) || 0,
            M: parseInt(producto.stockItem2) || 0,
            G: parseInt(producto.stockItem3) || 0,
            Xg: parseInt(producto.stockItem4) || 0,
            Xxg: parseInt(producto.stockItem5) || 0,
        };
        if (producto.esAccesorio === 'si') {
            return parseInt(producto.stockItem1) || parseInt(producto.stock) || 0;
        }
        return (stockMap[talla] ?? (parseInt(producto.stock) || 0));
    };

    const isMaxQuantity = (item) => {
        const disponible = getStockDisponible(item, item.item);
        const cantidadActual = parseInt(item.cantidad) || 0;
        return disponible > 0 && cantidadActual >= disponible;
    };

    const openModal = () => {
        setModalIsOpen(true);
        setIsFocused(true);
    };

    const closeModal = () => {
        setModalIsOpen(false);
        setIsFocused(false);
    };

    // const openModal2 = () => {
    //     setModalIsOpen2(true);
    // };

    const closeModal2 = () => {
        setModalIsOpen2(false);
        setCuentaExistente(false);
        setPasswordLogin('');
        setCrearCuenta(false);
        setPassword('');
    };

    const removeFromCart = (id, talla) => {
        const updatedCart = cartItems.filter(
            (producto) => !(producto.idProducto === id && producto.item === talla)
        );
        setCartItems(updatedCart);
        localStorage.setItem("cart", JSON.stringify(updatedCart));
        window.dispatchEvent(new Event('cartUpdated'));
    };

    const clearCart = () => {
        setCartItems([]);
        localStorage.removeItem('cart');
        window.dispatchEvent(new Event('cartUpdated'));
    };


    useEffect(() => {
        cargarCodigos();

    }, []);

    const cargarCodigos = () => {
        fetch(`${baseURL}/api/codigos`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setCodigos(data.codigos || []);
            })
            .catch(error => console.error('Error al cargar códigos:', error));
    };

    // Enviar mensaje a WhatsApp
    const handleWhatsappMessage = (extraNote = '') => {
        const codigoDescuento = codigos.find(
            (item) => item.codigo === cuponAplicado
        );
        let descuentoActualizado = codigoDescuento ? codigoDescuento.descuento : 0;

        // Calculamos total de productos con precio normal o mayoreo
        let totalPriceCalculado = 0;
        cartItems.forEach((item) => {
            totalPriceCalculado +=
                ftMostrarPrecioNormalMayoreo({ cuponAplicado, producto: item }) *
                item.cantidad;
        });
        // Aplico descuento
        let totalPriceWithDiscount = totalPriceCalculado - descuentoActualizado;
        if (totalPriceWithDiscount < 0) totalPriceWithDiscount = 0;

        // Sumamos costo de envío
        const finalTotal = totalPriceWithDiscount + shippingCost;

        const formattedTotal = finalTotal
            .toString()
            .replace(/\B(?=(\d{3})+(?!\d))/g, ".");

        const phoneNumber = `${contactos.telefono}`;

        const cartDetails = cartItems.map((item) => {
            const p = ftMostrarPrecioNormalMayoreo({ cuponAplicado, producto: item });
            return `\n✅ *${item.titulo}* 
       Cantidad: ${item.cantidad}
       Precio: ${moneda} ${p?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")} 
       ${item?.item}`;
        });

        let noteMessage = "";
        if (location.trim() !== "") noteMessage += `\n✅ Ubicación: ${location}`;
        if (name.trim() !== "") noteMessage += `\n✅ Nombre: ${name}`;
        if (email.trim() !== "") noteMessage += `\n✅ Email: ${email}`;
        if (noteText.trim() !== "") noteMessage += `\n✅ Nota: ${noteText}`;

        if (codigo.trim() !== "") {
            noteMessage += `\n✅ Codigo : ${codigo}
                      ✅ Descuento de : ${moneda} ${descuentoActualizado
                    ?.toString()
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ".")}`;
        }

        const entrega =
            deliveryOption === "express"
                ? "Estafeta express nacional: se enviará a domicilio"
                : deliveryOption === "mayoreo"
                    ? "Estafeta mayoreo: se enviará a domicilio"
                    : deliveryOption === "correos"
                        ? "Correos de México: se enviará a domicilio"
                        : "Moto Uber Guadalajara (costo al recibir)";

        const paymentMessage =
        paymentMethod === "transferencia"
            ? "Pago por transferencia bancaria"
            : paymentMethod === "efectivo"
                ? "Pago en efectivo"
                : paymentMethod === "pagoEnLinea"
                    ? "Pago en línea"
                    : "Otro (PayPal/Mercado Pago)"

        const message = `¡Hola! 🌟 Estoy interesado en encargar:
      ${cartDetails.join("")}
      ------------------------------------>
      ${noteMessage}
      ✅ ${entrega}
      ✅ ${paymentMessage}

      ------------------------------------>
      *Total con envío: ${moneda} ${formattedTotal}*
      *Descuento aplicado: ${moneda} ${descuentoActualizado}*
      *Costo de envío: ${moneda} ${shippingCost}*${extraNote ? `\n\n${extraNote}` : ''}
    `;

        const whatsappUrl = `https://api.whatsapp.com/send?phone=${phoneNumber}&text=${encodeURIComponent(
            message
        )}`;

        // Limpiamos campos
        setName("");
        setLocation("");
        setNoteText("");
        setCodigo("");
        setDescuento(descuentoActualizado);

        // Cerrar ambos modales
        // onClose(); // Cierra modal principal
        setModalIsOpen2(false);

        return whatsappUrl;
    };


    // Función para aumentar la cantidad de un producto en el carrito
    const increaseQuantity = (index) => {
        const updated = [...cartItems];
        const item = updated[index];
        if (isMaxQuantity(item)) {
            toast.error('Para esta talla, no hay mas inventario', { autoClose: 900 });
            return;
        }
        updated[index].cantidad = (updated[index].cantidad || 0) + 1;
        setCartItems(updated);
        localStorage.setItem('cart', JSON.stringify(updated));
        window.dispatchEvent(new Event('cartUpdated'));
    };

    // Función para disminuir la cantidad de un producto en el carrito
    const decreaseQuantity = (index) => {
        const updated = [...cartItems];
        if (updated[index].cantidad > 1) {
            updated[index].cantidad -= 1;
            setCartItems(updated);
            localStorage.setItem('cart', JSON.stringify(updated));
            window.dispatchEvent(new Event('cartUpdated'));
        }
    };


    //pedido-------------------------------------------------------------------
    const [mensaje, setMensaje] = useState('');

    const iniciarSesionYConfirmar = async () => {
        if (!passwordLogin.trim()) {
            toast.error('Ingresa tu contraseña', { autoClose: 2000 });
            return;
        }
        setMensaje('Verificando...');
        try {
            const loginData = await login(telefono.trim(), passwordLogin);
            if (loginData.cliente?.idCliente) {
                setCuentaExistente(false);
                setPasswordLogin('');
                await crearPedido(false, '', loginData.cliente.idCliente);
            } else {
                setMensaje('');
                toast.error(loginData.error || 'Contraseña incorrecta', { autoClose: 2500 });
            }
        } catch {
            setMensaje('');
            toast.error('Error de conexión', { autoClose: 2000 });
        }
    };

    const crearPedidoYRecuperar = () => {
        setCuentaExistente(false);
        setPasswordLogin('');
        crearPedido(false, 'REQUIERO APOYO PARA CAMBIAR MI CONTRASEÑA');
    };
    const [crearCuenta, setCrearCuenta] = useState(false);
    const [password, setPassword] = useState('');
    const [cuentaExistente, setCuentaExistente] = useState(false);
    const [passwordLogin, setPasswordLogin] = useState('');
    const crearPedido = async (registrar = false, extraWhatsappNote = '', idClienteOverride = null) => {
        if (cartConfig?.requiredFields?.nombre && !name.trim()) {
            toast.error('Ingresa tu nombre completo', { autoClose: 2000 });
            return;
        }
        if (cartConfig?.requiredFields?.telefono && !telefono.trim()) {
            toast.error('Ingresa tu teléfono / WhatsApp', { autoClose: 2000 });
            return;
        }
        if (cartConfig?.requiredFields?.email && !email.trim()) {
            toast.error('Ingresa tu correo electrónico', { autoClose: 2000 });
            return;
        }
        if (cartConfig?.requiredFields?.direccion && deliveryOption === 'delivery' && !address.trim()) {
            toast.error('Ingresa tu dirección de entrega', { autoClose: 2000 });
            return;
        }

        setMensaje('Procesando...');

        try {
            // Registro opcional antes de crear el pedido
            let idClienteRegistrado = null;
            if (!cliente && registrar && name.trim() && telefono.trim()) {
                if (password.length > 0 && password.length < 6) {
                    setMensaje('');
                    toast.error('La contraseña debe tener al menos 6 caracteres', { autoClose: 2500 });
                    return;
                }
                if (password.length >= 6) {
                    const regData = await register(telefono.trim(), password, name.trim());
                    if (regData.cliente?.idCliente) {
                        idClienteRegistrado = regData.cliente.idCliente;
                        toast.success('¡Cuenta creada! Ya puedes iniciar sesión en tu próxima compra.', { autoClose: 3500 });
                        // Guardar dirección y notas del formulario en el perfil recién creado
                        if (address.trim()) {
                            await clienteFetch(`${baseURL}/api/cliente/direcciones`, {
                                method: 'POST',
                                headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                                body: JSON.stringify({
                                    calle: address.trim(),
                                    referencias: noteText.trim(),
                                    esPredeterminada: true,
                                }),
                            });
                        }
                    } else {
                        // Teléfono ya registrado → pedir login inline
                        setMensaje('');
                        setCuentaExistente(true);
                        setPassword('');
                        return;
                    }
                }
            }

            // Construir la lista de productos del pedido
            const productosPedido = cartItems?.map(item => {
                return {
                    idProducto: item?.idProducto,
                    titulo: item?.titulo,
                    cantidad: item?.cantidad,
                    item: item?.item,
                    precio: item?.precio,
                    imagen: obtenerImagen(item)

                }
            });
            // Convertir la lista de productos a JSON
            const productosPedidoJSON = JSON.stringify(productosPedido);
            // Calcular el precio total del pedido
            let totalPrice = 0;
            cartItems.forEach(item => {
                totalPrice += item?.precio * item?.cantidad;
            });

            // Obtener el descuento del código de descuento
            const codigoDescuento = codigos?.find(item => item?.codigo === codigo);
            let descuentoCodigo = 0;

            if (codigoDescuento) {
                descuentoCodigo = codigoDescuento?.descuento;
            }

            // Aplicar el descuento del código de descuento
            const totalPriceWithDiscount = totalPrice - descuentoCodigo;

            // Enviar el pedido con el precio total descontado
            const formData = new FormData();

            formData.append('productos', productosPedidoJSON);
            formData.append('total', totalPriceWithDiscount);
            
            // Solo enviar campos obligatorios o con valor
            if (cartConfig?.requiredFields?.nombre || name.trim() !== '') {
                formData.append('nombre', name);
            }
            if (cartConfig?.requiredFields?.email || email.trim() !== '') {
                formData.append('email', email);
            }
            if (cartConfig?.requiredFields?.telefono || telefono.trim() !== '') {
                formData.append('telefono', telefono);
            }

            const entrega = deliveryOption === 'delivery' ? address : 'Retiro en personalmente';
            formData.append('entrega', entrega);

            formData.append('pago', paymentMethod);
            formData.append('nota', noteText);
            formData.append('codigo', codigo);
            formData.append('estado', 'Pendiente');
            const idClienteFinal = idClienteOverride || cliente?.idCliente || idClienteRegistrado;
            if (idClienteFinal) formData.append('idCliente', idClienteFinal);
            const response = await fetch(`${baseURL}/api/pedidos`, {
                method: 'POST',
                body: formData,
            });
            const data = await response.json();
            if (data.mensaje) {
                setMensaje('');
                Swal.fire(
                    'Pedido enviado!',
                    data.mensaje,
                    'success'
                );
                setName('')
                setCodigo('')
                setNoteText('')
                setEmail('')
                setCrearCuenta(false)
                setPassword('')
                closeModal()
                closeModal2()
                clearCart()
                localStorage.removeItem("cupon");
                setCuponAplicado("");

                if(paymentMethod === "pagoEnLinea") {
                    window.location.href = data.redirectURL;
                    return;
                }
                // Obtener la URL de WhatsApp y abrir en nueva pestaña
                const whatsappUrl = handleWhatsappMessage(extraWhatsappNote);

                // Crear un enlace y simular un clic en él para abrir en nueva pestaña
                const link = document.createElement('a');
                link.href = whatsappUrl;
                link.target = '_blank';
                link.rel = 'noopener noreferrer';
                document.body.appendChild(link);

                // Usar setTimeout para asegurar que el clic ocurra después de que el navegador haya procesado el evento actual
                setTimeout(() => {
                    link.click();
                    document.body.removeChild(link);
                }, 100);

            } else if (data?.error) {
                setMensaje('');
                Swal.fire(
                    'Error',
                    data?.error,
                    'error'
                );
            }
        } catch (error) {
            console.error('Error:', error);
            setMensaje('');
            Swal.fire(
                'Error',
                'Error de conexión. Por favor, inténtelo de nuevo.',
                'error'
            );

        }
    };

    const handleSubmitCupon = (e, accion) => {
        e.preventDefault();
        if (accion === "Agregar") {
            const cupones = codigos.map((item) => item.codigo);
            if (cupones.includes(cupon.toUpperCase())) {
                localStorage.setItem("cupon", cupon.toUpperCase());
                setCuponAplicado(
                    e.target.value?.length > 0
                        ? e.target.value.toUpperCase()
                        : e.target.value
                );
                setSincronizarStates(true);
                toast.success("Cupón aplicado", { autoClose: 1000 });
            } else {
                toast.error("Cupón no válido", { autoClose: 1000 });
                return;
            }
        } else {
            localStorage.removeItem("cupon");
            setCuponAplicado("");
            setCupon("");
            setSincronizarStates(false);
            toast.success("Cupón eliminado", { autoClose: 1000 });
        }
    };

    // Cálculo del subtotal de productos (sin envío)
    const subtotalProductos = totalPrice - descuento < 0 ? 0 : totalPrice - descuento;

    // Cálculo final con descuento y envío (para mostrarlo en la vista previa del carrito)
    const finalPrice = subtotalProductos + shippingCost;

    const totalArticulos = cartItems.reduce((total, producto) => total + producto.cantidad, 0);
    return (
        <div>
            {/* <ToastContainer /> */}
            <button onClick={openModal} className='cartIconFixed'>
                {
                    // Calcular el total de artículos
                    <span>{totalArticulos}</span>
                }
                <FontAwesomeIcon icon={faShoppingCart} />
            </button>

            <Modal
                isOpen={modalIsOpen}
                className="modal-cart"
                overlayClassName="overlay-cart"
                onRequestClose={closeModal}
            >
                <div className='deFLex'>
                    <button onClick={closeModal} ><FontAwesomeIcon icon={faArrowLeft} />  </button>
                    <button onClick={clearCart} className='deleteToCart'>Vaciar carrito</button>
                </div>
                {cartItems?.length === 0 ?
                    (<p className='nohay'> No hay productos</p>)
                    : (<>
                        <div className="modal-content-cart">


                            {loading ? (
                                <p>Cargando...</p>
                            ) : (
                                <div>

                                    {cartItems.map((item, index) => (
                                        <div key={`${item?.idProducto}-${item?.item}-${index}`} className='cardProductCart' >
                                            {activateAnchor ? (
                                                <Anchor
                                                    to={`/producto/${item?.idProducto
                                                        }/${item?.titulo?.replace(/\s+/g, "-")}`}
                                                    onClick={false}
                                                >
                                                    <img src={obtenerImagen(item)} alt="imagen" />
                                                </Anchor>
                                            ) : (
                                                <img src={obtenerImagen(item)} alt="imagen" />
                                            )}
                                            <div className='cardProductCartText'>
                                                <h3>{item.titulo}</h3>
                                                <span>
                                                    {item?.item}
                                                </span>
                                                <strong>
                                                    {moneda}{" "}
                                                    {ftMostrarPrecioNormalMayoreo({
                                                        cuponAplicado,
                                                        producto: item,
                                                    })
                                                        ?.toString()
                                                        .replace(/\B(?=(\d{3})+(?!\d))/g, ".")}
                                                </strong>
                                            </div>
                                            <div className="deColumn">
                                                <button
                                                    onClick={() =>
                                                        removeFromCart(item.idProducto, item.item)
                                                    }
                                                    className="deleteCart"
                                                >
                                                    <FontAwesomeIcon icon={faTrash} />
                                                </button>
                                                <div className="deFlexCantidad">
                                                    <button onClick={() => decreaseQuantity(index)}>
                                                        -
                                                    </button>
                                                    <span>{item.cantidad}</span>
                                                    <button
                                                        onClick={() => increaseQuantity(index)}
                                                        disabled={isMaxQuantity(item)}
                                                    >
                                                        +
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                        {/* Sección para agregar cupón */}
                        <div className="addCuponCartContainer">
                            <form
                                onSubmit={(e) =>
                                    handleSubmitCupon(
                                        e,
                                        `${cuponAplicado ? "Eliminar" : "Agregar"}`
                                    )
                                }
                            >
                                <div className="cuponCartContainer">
                                    <img src={cuponImage} alt="cuponImage" style={{ width: "40px", height: "40px" }} />
                                    <h4>Aplicar cupón:</h4>
                                </div>
                                <input
                                    type="text"
                                    value={cuponAplicado || cupon}
                                    onChange={(e) => {
                                        setCupon(e.target.value.toLocaleUpperCase());
                                    }}
                                    required
                                    maxLength={20}
                                    disabled={cuponAplicado}
                                />

                                <div>
                                    <button
                                        type="submit"
                                        className={`${cuponAplicado ? "btnDelCupon" : "btnAddCupon"
                                            }`}
                                    >
                                        {cuponAplicado ? "Eliminar" : "Agregar"}
                                    </button>
                                </div>
                            </form>
                        </div>
                        <div className="deColumnCart">
                            {/* Subtotal sin envío */}
                            <h4>
                                Importe: {moneda}{" "}
                                {subtotalProductos?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}
                            </h4>
                            <h4>
                                {cuponAplicado
                                    ? (() => {
                                        let required = 0;
                                        let cuponName = '';
                                        
                                        if (cupon === "MAYOREO30" || cuponAplicado === "MAYOREO30") {
                                            required = 30;
                                            cuponName = 'MAYOREO30';
                                        } else if (cupon === "MAYOREO50" || cuponAplicado === "MAYOREO50") {
                                            required = 50;
                                            cuponName = 'MAYOREO50';
                                        } else if (cupon === "MAYOREO100" || cuponAplicado === "MAYOREO100") {
                                            required = 100;
                                            cuponName = 'MAYOREO100';
                                        } else if (cupon === "MAYOREO200" || cuponAplicado === "MAYOREO200") {
                                            required = 200;
                                            cuponName = 'MAYOREO200';
                                        } else if (cupon === "TORZOLOVER" || cuponAplicado === "TORZOLOVER") {
                                            required = 30;
                                            cuponName = 'TORZOLOVER';
                                        } else if (cupon === "TORZOQUEEN" || cuponAplicado === "TORZOQUEEN") {
                                            required = 50;
                                            cuponName = 'TORZOQUEEN';
                                        } else if (cupon === "TORZOKING" || cuponAplicado === "TORZOKING") {
                                            required = 100;
                                            cuponName = 'TORZOKING';
                                        } else if (cupon === "TORZOSUPRIME" || cuponAplicado === "TORZOSUPRIME") {
                                            required = 200;
                                            cuponName = 'TORZOSUPRIME';
                                        }
                                        
                                        if (required > 0) {
                                            const faltan = Math.max(0, required - totalArticulos);
                                            return `Prendas: ${totalArticulos} de ${required} (faltan ${faltan})`;
                                        }
                                        return `Prendas: ${totalArticulos} piezas`;
                                    })()
                                    : `Prendas: ${totalArticulos} piezas`}
                            </h4>

                            <div className="deFLexBtns">
                                {/* Abrir segundo modal para datos del pedido */}
                                {cuponAplicado
                                    ? (() => {
                                        let required = 0;
                                        
                                        if (cupon === "MAYOREO30" || cuponAplicado === "MAYOREO30" || cupon === "TORZOLOVER" || cuponAplicado === "TORZOLOVER") {
                                            required = 30;
                                        } else if (cupon === "MAYOREO50" || cuponAplicado === "MAYOREO50" || cupon === "TORZOQUEEN" || cuponAplicado === "TORZOQUEEN") {
                                            required = 50;
                                        } else if (cupon === "MAYOREO100" || cuponAplicado === "MAYOREO100" || cupon === "TORZOKING" || cuponAplicado === "TORZOKING") {
                                            required = 100;
                                        } else if (cupon === "MAYOREO200" || cuponAplicado === "MAYOREO200" || cupon === "TORZOSUPRIME" || cuponAplicado === "TORZOSUPRIME") {
                                            required = 200;
                                        }
                                        
                                        if (required > 0) {
                                            return totalArticulos >= required 
                                                ? <button className="btnWpp" onClick={openModal2}>Comprar</button> 
                                                : <button className="btnWppDisabled">Comprar</button>;
                                        }
                                        return <button className="btnWpp" onClick={openModal2}>Comprar</button>;
                                    })()
                                    : <button className="btnWpp" onClick={openModal2}>Comprar</button>
                                }

                            </div>
                        </div>

                        {/* Sub-modal de detalles para el pedido (WhatsApp, etc.) */}
                        <Modal
                            isOpen={modalIsOpen2}
                            onRequestClose={closeModal2}
                            className="modal-cart"
                            overlayClassName="overlay-cart"
                        >
                            <div className="deFLex">
                                {/* Botón de regreso dentro del segundo modal */}
                                <button onClick={closeModal2}>
                                    <FontAwesomeIcon icon={faArrowLeft} />
                                </button>
                                <h4>Agregar Detalles</h4>
                            </div>

                            <div className="modal-send-form">
                                {cartConfig?.requiredFields?.nombre && (
                                    <input
                                        type="text"
                                        id="name"
                                        value={name}
                                        onChange={(e) => setName(e.target.value)}
                                        placeholder="Nombre completo (obligatorio)"
                                        autoComplete="on"
                                        required
                                    />
                                )}

                                {cartConfig?.requiredFields?.telefono && (
                                    <input
                                        type="tel"
                                        id="telefono"
                                        value={telefono}
                                        onChange={(e) => setTelefono(e.target.value)}
                                        placeholder="Teléfono/WhatsApp (obligatorio)"
                                        autoComplete="tel"
                                        required
                                    />
                                )}

                                {cartConfig?.requiredFields?.email && (
                                    <input
                                        type="email"
                                        id="email"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        placeholder="Correo electrónico (obligatorio)"
                                        autoComplete="on"
                                        required
                                    />
                                )}

                                <div className="deFLexRadio">
                                    <label>Envío</label>

                                    {/* 1) Express = $160 */}
                                    <div onClick={() => setDeliveryOption("express")}>
                                        <input
                                            type="radio"
                                            id="express"
                                            name="deliveryOption"
                                            value="express"
                                            checked={deliveryOption === "express"}
                                            onChange={() => setDeliveryOption("express")}
                                            autoComplete="on"
                                        />
                                        <label htmlFor="express">
                                            Estafeta 1-10 prendas (2-5 días) $160
                                        </label>
                                    </div>

                                    {/* 2) Mayoreo = $250 */}
                                    <div onClick={() => setDeliveryOption("mayoreo")}>
                                        <input
                                            type="radio"
                                            id="mayoreo"
                                            name="deliveryOption"
                                            value="mayoreo"
                                            checked={deliveryOption === "mayoreo"}
                                            onChange={() => setDeliveryOption("mayoreo")}
                                            autoComplete="on"
                                        />
                                        <label htmlFor="mayoreo">
                                            Estafeta 30-200 prendas (2-5 días) $250
                                        </label>
                                    </div>

                                    {/* 3) Correos = $60 */}
                                    <div onClick={() => setDeliveryOption("correos")}>
                                        <input
                                            type="radio"
                                            id="correos"
                                            name="deliveryOption"
                                            value="correos"
                                            checked={deliveryOption === "correos"}
                                            onChange={() => setDeliveryOption("correos")}
                                            autoComplete="on"
                                        />
                                        <label htmlFor="correos">Correos de México (5-10 días) $60</label>
                                    </div>

                                    {/* 4) Moto uber = costo al recibir */}
                                    <div onClick={() => setDeliveryOption("moto")}>
                                        <input
                                            type="radio"
                                            id="moto"
                                            name="deliveryOption"
                                            value="moto"
                                            checked={deliveryOption === "moto"}
                                            onChange={() => setDeliveryOption("moto")}
                                            autoComplete="on"
                                        />
                                        <label htmlFor="moto">
                                            Moto Uber en Guadalajara $ al recibir
                                        </label>
                                    </div>
                                </div>

                                {cartConfig?.requiredFields?.direccion && (
                                    <input
                                        type="text"
                                        id="address"
                                        name="address"
                                        value={address}
                                        onChange={(e) => setAddress(e.target.value)}
                                        placeholder="Calle, número, colonia, ciudad, código postal (obligatorio)"
                                        autoComplete="on"
                                        required
                                    />
                                )}

                                <div className="deFLexRadio">
                                    <label>Formas de pago</label>

                                    {cartConfig?.paymentOptions?.showBankTransfer && (
                                        <div>
                                            <input
                                                type="radio"
                                                id="transferencia"
                                                name="paymentMethod"
                                                value="transferencia"
                                                checked={paymentMethod === "transferencia"}
                                                onChange={() => setPaymentMethod("transferencia")}
                                                autoComplete="on"
                                            />
                                            <label htmlFor="transferencia">Transferencia bancaria</label>
                                        </div>
                                    )}

                                    {cartConfig?.paymentOptions?.showCashPayment && (
                                        <div>
                                            <input
                                                type="radio"
                                                id="efectivo"
                                                name="paymentMethod"
                                                value="efectivo"
                                                checked={paymentMethod === "efectivo"}
                                                onChange={() => setPaymentMethod("efectivo")}
                                                autoComplete="on"
                                            />
                                            <label htmlFor="efectivo">Deposito en efectivo</label>
                                        </div>
                                    )}

                                    {cartConfig?.paymentOptions?.showOnlinePayment && (
                                        <div>
                                            <input
                                                type="radio"
                                                id="pagoEnLinea"
                                                name="paymentMethod"
                                                value="pagoEnLinea"
                                                checked={paymentMethod === "pagoEnLinea"}
                                                onChange={() => setPaymentMethod("pagoEnLinea")}
                                                autoComplete="on"
                                            />
                                            <label htmlFor="pagoEnLinea">Pago en Línea</label>
                                        </div>
                                    )}

                                    {cartConfig?.paymentOptions?.showOtherPayment && (
                                        <div>
                                            <input
                                                type="radio"
                                                id="otro"
                                                name="paymentMethod"
                                                value="otro"
                                                checked={paymentMethod === "otro"}
                                                onChange={() => setPaymentMethod("otro")}
                                                autoComplete="on"
                                            />
                                            <label htmlFor="otro">Otro (PayPal/Mercado Pago)</label>
                                        </div>
                                    )}
                                </div>

                                <textarea
                                    placeholder="Agrega una nota (opcional)"
                                    value={noteText}
                                    onChange={(e) => setNoteText(e.target.value)}
                                />
                                <fieldset className="deNonefieldset">
                                    <legend>Productos</legend>
                                    <textarea
                                        name="productos"
                                        value={cartItems
                                            .map(
                                                (item) =>
                                                    `${item.titulo}, x ${item.cantidad}, ${item.item}, ${item.categoria
                                                    }, ${item.precio}, ${obtenerImagen(item)}`
                                            )
                                            .join("\n")}
                                        readOnly
                                    />
                                </fieldset>

                                {/* Botones para finalizar pedido */}
                                {mensaje ? (
                                    <button type="button" className="btn" disabled>
                                        {mensaje}
                                    </button>
                                ) : paymentMethod === "pagoEnLinea" ? (
                                    <div style={{ padding: "20px 40px" }}>
                                        <button type="button" onClick={() => crearPedido(false)} className="btnPagar">
                                            Pagar
                                        </button>
                                    </div>
                                ) : cliente ? (
                                    <div style={{ padding: "20px 40px" }}>
                                        <button type="button" onClick={() => crearPedido(false)} className="btnWpp">
                                            Confirmar pedido
                                            <img src={whatsappIcon} alt="WhatsApp" />
                                        </button>
                                    </div>
                                ) : cuentaExistente ? (
                                    <div className="cart-checkout-actions">
                                        <div className="cart-cuenta-existente-msg">
                                            <FontAwesomeIcon icon={faLock} />
                                            <span>Ya tienes una cuenta con ese número. Ingresa tu contraseña para vincular el pedido.</span>
                                        </div>
                                        <input
                                            type="password"
                                            className="cart-registro-pass"
                                            placeholder="Tu contraseña"
                                            value={passwordLogin}
                                            onChange={(e) => setPasswordLogin(e.target.value)}
                                            autoComplete="current-password"
                                            onKeyDown={(e) => e.key === 'Enter' && iniciarSesionYConfirmar()}
                                        />
                                        <button type="button" className="btn-cuenta-primary" onClick={iniciarSesionYConfirmar}>
                                            <span className="btn-cuenta-primary-main">
                                                <FontAwesomeIcon icon={faCheck} />
                                                Iniciar sesión y confirmar
                                            </span>
                                            <span className="btn-cuenta-primary-sub">
                                                Vincula el pedido a tu cuenta
                                            </span>
                                        </button>
                                        <button type="button" className="btn-wpp-ghost" onClick={crearPedidoYRecuperar}>
                                            Crear pedido y recuperar contraseña
                                            <img src={whatsappIcon} alt="WhatsApp" className="btn-wpp-ghost-icon" />
                                        </button>
                                    </div>
                                ) : (
                                    <div className="cart-checkout-actions">
                                        {crearCuenta && (
                                            <input
                                                type="password"
                                                className="cart-registro-pass"
                                                placeholder="Contraseña (mín. 6 caracteres)"
                                                value={password}
                                                onChange={(e) => setPassword(e.target.value)}
                                                autoComplete="new-password"
                                            />
                                        )}
                                        <button
                                            type="button"
                                            className="btn-cuenta-primary"
                                            onClick={() => {
                                                if (!crearCuenta) {
                                                    setCrearCuenta(true);
                                                } else if (password.trim().length < 6) {
                                                    toast.error('Ingresa una contraseña de al menos 6 caracteres', { autoClose: 2500 });
                                                } else {
                                                    crearPedido(true);
                                                }
                                            }}
                                        >
                                            <span className="btn-cuenta-primary-main">
                                                <FontAwesomeIcon icon={faCheck} />
                                                Crear cuenta y confirmar
                                            </span>
                                            <span className="btn-cuenta-primary-sub">
                                                Guardar tus datos
                                            </span>
                                        </button>
                                        <button type="button" onClick={() => crearPedido(false)} className="btn-wpp-ghost">
                                            Confirmar pedido
                                            <img src={whatsappIcon} alt="WhatsApp" className="btn-wpp-ghost-icon" />
                                        </button>
                                    </div>
                                )}
                            </div>
                        </Modal>

                    </>)}

            </Modal>
        </div >
    );
}
